/**
 * Import the sagas from the features and pass to fork as an array.
 */

import { fork, all } from 'redux-saga/effects';
import SideBarWatcher from 'features/side-bar/SideBar.watcher';
import AuthorizeWatcher from 'features/authorize/Authorize.watcher';
import ViewProfileDialogWatcher from 'features/view-profile-dialog/ViewProfileDialog.watcher';
import NotificationWatcher from 'features/NotificationsPopup/Notifications.watcher';
import UserEntitledAppsWatcher from 'features/user-entitled-apps/UserEntitledApps.watcher';

export default function* startForman() {
  yield all([
    fork(SideBarWatcher),
    fork(AuthorizeWatcher),
    fork(ViewProfileDialogWatcher),
    fork(NotificationWatcher),
    fork(UserEntitledAppsWatcher),
  ]);
}
